import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useOrganizationContext } from '../utils/useOrganizationContext'
// import Spinning from './Common/Spinner/Spinning'

export const OnlyWithOrganization = () => {
  const location = useLocation()

  const { organizationId } = useOrganizationContext()

  if (!organizationId) {
    return (
      <Navigate
        to="/app/workspaces"
        state={{
          returnUrl: location.pathname + location.search + location.hash,
        }}
      />
    )
  }

  return <Outlet />
}
